<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="fmh1"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><b>CONTENTS</b></span></p>
<p class="toc0" id="tit"><span href="#/text/Title" title="Link target outside of Sample"><b>TITLE PAGE</b></span></p>
<p class="toc" id="copy"><span href="#/text/Copyright" title="Link target outside of Sample"><b>COPYRIGHT</b></span></p>
<p class="toc" id="ded"><span href="#/text/Dedication" title="Link target outside of Sample"><b>DEDICATION</b></span></p>
<p class="toc1" id="ch1"><a href="#/text/Chapter001">El Qué Dirán</a></p>
<p class="toc" id="ch2"><span href="#/text/Chapter002" title="Link target outside of Sample">Holyoke, Mass.: An Ethnography</span></p>
<p class="toc" id="ch3"><span href="#/text/Chapter003" title="Link target outside of Sample">The Simple Truth</span></p>
<p class="toc" id="ch4"><span href="#/text/Chapter004" title="Link target outside of Sample">Summer of Nene</span></p>
<p class="toc" id="ch5"><span href="#/text/Chapter005" title="Link target outside of Sample">Some Springs Girls Do Die</span></p>
<p class="toc" id="ch6"><span href="#/text/Chapter006" title="Link target outside of Sample">The Belindas</span></p>
<p class="toc" id="ch7"><span href="#/text/Chapter007" title="Link target outside of Sample">La Hija de Changó</span></p>
<p class="toc" id="ch8"><span href="#/text/Chapter008" title="Link target outside of Sample">The Light in the Sky</span></p>
<p class="toc" id="ch9"><span href="#/text/Chapter009" title="Link target outside of Sample">Love War Stories</span></p>
<p class="toc" id="ack"><span href="#/text/Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc" id="cre"><span href="#/text/Credits" title="Link target outside of Sample">Credits</span></p>
<p class="toc1" id="ata"><span href="#/text/About_the_Author" title="Link target outside of Sample"><b>ABOUT THE AUTHOR</b></span></p>
<p class="toc" id="also"><span href="#/text/Also_by" title="Link target outside of Sample"><b>ALSO BY FEMINIST PRESS</b></span></p>
<p class="toc" id="afp"><span href="#/text/About_Feminist_Press" title="Link target outside of Sample"><b>ABOUT FEMINIST PRESS</b></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0ece0e1d